import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PaginatedPayoutApiResponse, PayoutResponse } from "@customTypes/payout";

import { dashboardQKeys } from "./queryKeys";


export const useGetPayouts = ({
  status,
  pagination,
}: {
  status?: string;
  pagination?: { page: number; pageSize: number };
}) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.payoutsWithFilters({ status, pagination }),
    queryFn: () => {
      return api.get<PaginatedPayoutApiResponse>("payouts/dashboard/history", {
        params: {
          status: status !== "all" ? status : undefined,
          page: pagination?.page || 1,
          page_size: pagination?.pageSize || 50,
        },
      });
    },
    select: (res): PayoutResponse => {
      const { items, pagination: responsePagination } = res.data;
      return {
        newData: items.map(item => ({
          ...item,
          id: item.id || item._id || "",
        })),
        total: responsePagination.total,
        page: responsePagination.page,
        pageSize: responsePagination.page_size,
        pageCount: responsePagination.page_count,
      };
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    onError: (res: any) => {
      console.error("[From Get Payouts]", res);
      handleErrors(res, "query");
    },
  });
};
